import { useState } from 'react';

export default function ExportTourOperatorLogo({
  tourOperator,
  noImage = false,
  compact = false,
}) {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <div>
      {tourOperator?.avatarUrl && !noImage && !imageFailed ? (
        <img
          src={tourOperator?.avatarUrl}
          alt={tourOperator?.displayName ?? 'logo'}
          onError={() => setImageFailed(true)}
          className={
            compact ? 'h-6 w-auto object-contain' : 'h-10 w-auto object-contain'
          }
        />
      ) : (
        <div className={compact ? 'text-sm font-semibold' : 'text-3xl'}>
          {tourOperator?.displayName}
        </div>
      )}
    </div>
  );
}
